module.exports = __webpack_public_path__ + "img/open11.7c7e7e03.png";